import { render, staticRenderFns } from "./sourceCell.vue?vue&type=template&id=64162af6&scoped=true"
import script from "./sourceCell.vue?vue&type=script&lang=js"
export * from "./sourceCell.vue?vue&type=script&lang=js"
import style0 from "./sourceCell.vue?vue&type=style&index=0&id=64162af6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64162af6",
  null
  
)

export default component.exports